import * as React from 'react';
import { connect } from 'react-redux';

import { siteUrlsSelector } from '../../../app/selectors/SiteUrlsSelectors';
import { DetailsTooltipStyles } from '../../../app/spaces/CardView/DetailsTooltipStyles';
import { Thumbnail } from '../../../app/spaces/CardView/Thumbnail';
import { Hover } from '../../../app/spaces/Components/Hover';
import { SpacesSiteUrls } from '../../../app/spaces/SpacesSiteUrls';
import { TooltipAnchor } from '../../../app/spaces/Tooltips/TooltipAnchor';
import { isViewTooltipContentUnfocusable, ViewTooltip } from '../../../app/spaces/Tooltips/ViewTooltip';
import { AppState } from '../../../app/state/AppState';
import { isFavoritesSpace } from '../../../app/state/SpaceInfo';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { Views } from '../../../views/resources/Views';

export interface ConnectedViewThumbnailOwnProps {
    connectedViewId: string;
    connectedViewThumbnailUrl: string;
    connectedViewUrl: string;
}

export interface ConnectedViewThumbnailStateProps {
    urls: SpacesSiteUrls;
    allowDragAndDrop: boolean;
}

export interface ConnectedViewThumbnailStates {
    isHovered: boolean;
    connectedViewContentInfo: IContentInfo;
}

export type ConnectedViewThumbnailProps = ConnectedViewThumbnailOwnProps & ConnectedViewThumbnailStateProps;

export const THUMBNAIL_WIDTH = 177;
export const THUMBNAIL_HEIGHT = 108;

export class ConnectedViewThumbnailPresentation extends React.PureComponent<ConnectedViewThumbnailProps, ConnectedViewThumbnailStates> {
    constructor(props: ConnectedViewThumbnailProps) {
        super(props);

        this.state = {
            isHovered: false,
            connectedViewContentInfo: null
        };

        this.getViewContentDetail();
    }

    public componentDidUpdate(prevProps: ConnectedViewThumbnailProps) {
        if (prevProps.connectedViewId !== this.props.connectedViewId) {
            this.getViewContentDetail();
        }
    }

    public render() {
        const disableAutoFocus = isViewTooltipContentUnfocusable(this.state.connectedViewContentInfo);

        return <div style={{ width: THUMBNAIL_WIDTH + 'px' }}>
            <Hover groupName="metric-detail-connected-view" onEnter={this.activateHover} onLeave={this.deactivateHover}>
                {this.state.connectedViewContentInfo ?
                    <TooltipAnchor tooltipContent={this.renderTooltipContent}
                        width={DetailsTooltipStyles.Width}
                        title={Messages.viewTooltipTitle()} disableAutoFocus={disableAutoFocus}>
                        {this.renderThumbnail()}
                    </TooltipAnchor>
                    : this.renderThumbnail()
                }
            </Hover>
        </div>;
    }

    private renderThumbnail = () => {
        return <Thumbnail navigateUrl={this.props.connectedViewUrl}
            openLinkInNewTab
            defaultImageUrl={imgPath('spaces_card_view.svg')}
            thumbnailImageUrl={this.props.connectedViewThumbnailUrl}
            hoveredOrSelected={this.state.isHovered}
            customHeight={THUMBNAIL_HEIGHT}
            allowDragAndDrop={this.props.allowDragAndDrop}
            allowFocusIndicator />;
    }

    private activateHover = () => {
        this.setState({ isHovered: true });
    }

    private deactivateHover = () => {
        this.setState({ isHovered: false });
    }

    private getViewContentDetail = async () => {
        try {
            const result = await Views.getById(this.props.connectedViewId);
            this.setState({ connectedViewContentInfo: { ...result } });
        } catch (e) {
            this.setState({ connectedViewContentInfo: null });
        }
    }

    private renderTooltipContent = () => {
        return this.state.connectedViewContentInfo ? <ViewTooltip content={this.state.connectedViewContentInfo}
            urls={this.props.urls}
            inProjectSpace={false} /> : null;
    }
}

const mapStateToProps: MapStateToProps<ConnectedViewThumbnailStateProps> = (state: AppState) => {
    return {
        urls: siteUrlsSelector(state),
        allowDragAndDrop: isFavoritesSpace(state.spaceInfo), // soon collections too!
    };
};

export const ConnectedViewThumbnail = connect(mapStateToProps)(ConnectedViewThumbnailPresentation);
